"use client";

import React from "react";
import { Mail, Phone, MapPin, Send, Loader2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="h-full flex flex-col items-center justify-center text-center p-8 bg-primary/5 border border-primary/20 rounded-sm backdrop-blur-sm animate-in fade-in zoom-in duration-500">
        <div className="size-16 rounded-none bg-primary/20 flex items-center justify-center mb-4 border border-primary/50">
          <Send className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-mono uppercase tracking-tighter text-foreground mb-2">Transmission Successful</h3>
        <p className="text-muted-foreground font-mono text-sm">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[14px] font-mono uppercase tracking-widest text-muted-foreground">Operator Name</FormLabel>
              <FormControl>
                <Input placeholder="ENTER IDENTITY..." {...field} className="bg-transparent border-t-0 border-x-0 border-b border-[#A5A9B4] rounded-none text-foreground placeholder:text-muted-foreground/30 focus-visible:ring-0 focus-visible:border-primary focus-visible:shadow-[0_4px_12px_-4px_rgba(0,127,255,0.4)] h-12 transition-all duration-300" />
              </FormControl>
              <FormMessage className="text-destructive font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[14px] font-mono uppercase tracking-widest text-muted-foreground">Communication Node</FormLabel>
              <FormControl>
                <Input type="email" placeholder="NODE@NETWORK.ACCESS" {...field} className="bg-transparent border-t-0 border-x-0 border-b border-[#A5A9B4] rounded-none text-foreground placeholder:text-muted-foreground/30 focus-visible:ring-0 focus-visible:border-primary focus-visible:shadow-[0_4px_12px_-4px_rgba(0,127,255,0.4)] h-12 transition-all duration-300" />
              </FormControl>
              <FormMessage className="text-destructive font-mono text-xs" />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[14px] font-mono uppercase tracking-widest text-muted-foreground">Direct Line</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+00 000 000 000" {...field} className="bg-transparent border-t-0 border-x-0 border-b border-[#A5A9B4] rounded-none text-foreground placeholder:text-muted-foreground/30 focus-visible:ring-0 focus-visible:border-primary focus-visible:shadow-[0_4px_12px_-4px_rgba(0,127,255,0.4)] h-12 transition-all duration-300" />
              </FormControl>
              <FormMessage className="text-destructive font-mono text-xs" />
            </FormItem>} />

        <FormField control={control} name="subject" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[14px] font-mono uppercase tracking-widest text-muted-foreground">Protocol Subject</FormLabel>
              <FormControl>
                <Input placeholder="DEFINE INTENT..." {...field} className="bg-transparent border-t-0 border-x-0 border-b border-[#A5A9B4] rounded-none text-foreground placeholder:text-muted-foreground/30 focus-visible:ring-0 focus-visible:border-primary focus-visible:shadow-[0_4px_12px_-4px_rgba(0,127,255,0.4)] h-12 transition-all duration-300" />
              </FormControl>
              <FormMessage className="text-destructive font-mono text-xs" />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-[14px] font-mono uppercase tracking-widest text-muted-foreground">Transmission Details</FormLabel>
            <FormControl>
              <Textarea placeholder="AWAITING INPUT..." {...field} className="bg-transparent border-t-0 border-x-0 border-b border-[#A5A9B4] rounded-none text-foreground placeholder:text-muted-foreground/30 focus-visible:ring-0 focus-visible:border-primary focus-visible:shadow-[0_4px_127px_-4px_rgba(0,127,255,0.4)] min-h-[150px] resize-none transition-all duration-300" />
            </FormControl>
            <FormMessage className="text-destructive font-mono text-xs" />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-sm">
          <p className="text-destructive font-mono text-xs">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-14 bg-primary hover:bg-primary/90 text-primary-foreground font-mono text-lg uppercase tracking-widest rounded-sm transition-all duration-300 shadow-sm hover:shadow-md">
        {isSubmitting ? <>
            <Loader2 className="mr-2 size-5 animate-spin" />
            SENDING...
          </> : "INITIALIZE UPLINK"}
      </Button>
    </Form>;
}
export default function Contact() {
  return;
}